import { configureStore } from '@reduxjs/toolkit'
import configSlice from './config.slice';
import cardsSlice from './cards.slice';

const store = configureStore({
    reducer: {
      config: configSlice,
      cards: cardsSlice
    },
  })

export default store;